import { render, staticRenderFns } from "./remindListTop.vue?vue&type=template&id=2b0f8756&scoped=true&"
import script from "./remindListTop.vue?vue&type=script&lang=js&"
export * from "./remindListTop.vue?vue&type=script&lang=js&"
import style0 from "./remindListTop.vue?vue&type=style&index=0&id=2b0f8756&prod&scoped=true&lang=css&"
import style1 from "./remindListTop.vue?vue&type=style&index=1&id=2b0f8756&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0f8756",
  null
  
)

export default component.exports